import React, { useState, useEffect } from 'react';
import { LoadEffect, TableLoader } from '../component/loader';
import axios from 'axios';
import PageHeader from '../component/pageheader';
import { config, API_URL, familyCode } from '../component/include';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
// Using standard HTML date inputs instead of react-datepicker
import Error403 from '../settings/error403';

import { formatGroupLabel, getClassArm, getClassName} from '../component/globalFunction'
import { useSelector } from 'react-redux'
import Select from 'react-select'


const Homework = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const [studentList, setStudentList] = useState([]);
 const schoolClass  = useSelector(state => state.rootReducer.schoolClass);


  const [filters, setFilters] = useState({
    studentClass:[],
    subject:[],
    student_name: '',
    admission_number: '',

    start_date: null,
    end_date: null
  });


  const [notice, setNotice] = useState({
    isLoading: false,
    isError: false,
    message: ''
  });


  const { SearchBar } = Search;


  
  const fetchStudentList = async () => {
    setNotice({ ...notice, isLoading: true });
   
    try {

  const response = await axios.get(`${API_URL}/homework/student_family/${familyCode}`, config);
      
      if (Array.isArray(response.data.data) && response.data.status === 200) {

        response.data.data.forEach(element => {
          //random unique 8 digit string
          element.code = Math.random().toString(36).substring(2, 10);
           
           element.className = getClassName(element.classID, element.sectionID, schoolClass)
               });

        setStudentList(response.data.data);

        //scroll to end
        window.scrollTo(0, document.body.scrollHeight);
        setNotice({ isLoading: false, isError: false, message: '' });
      } else {
        setStudentList([]);
        setNotice({ isLoading: false, isError: true, message: 'No record found' });
      }
    } catch (error) {
      setStudentList([]);
      setNotice({ isLoading: false, isError: true, message: 'Error fetching student list' });
    }
  };



useEffect(()=>{
  if(schoolClass){
  fetchStudentList()
}
},[schoolClass])

 

 



  const handlePreviewHomework = (row) => {
    
    //set homework_code in a session storage
    localStorage.setItem('homework_code', row.homework_code)
    
    window.open(`/students/homework/preview/${row.student_code}`, '_blank');
  };



  const columnStudent = [
    
    {
      dataField: 'actions',
      text: 'Actions',
      formatter: (cell, row) => {
        return (
          <div className="d-flex">
            <button 
              type="button"
              className="btn btn-info btn-sm mr-2" 
              onClick={() => handlePreviewHomework(row)}
            >
              <i className="fa fa-eye"></i> View
            </button>
          </div>
        );
      }
    },
    {
      dataField: 'studentName',
      text: 'Student Name',
      formatter: (cell, row) => <div style={{whiteSpace: 'pre-wrap', wordWrap: 'break-word', width: '200px'}}>{row.studentName+ ' (' + row.admissionNumber + ')' }</div>,
      sort: true
    },
    {
      dataField: 'homework_date',
      text: 'Homework Date',
      formatter: (cell, row) => row.homework_date,
      sort: true
    },
    {
      dataField: 'default_return_date',
      text: 'Return Date',
      formatter: (cell, row) => row.default_return_date,
      sort: true
    },
    {
      dataField: 'behavior_comments',
      text: 'Behavior Comments',
      formatter: (cell, row) => <div style={{whiteSpace: 'pre-wrap', wordWrap: 'break-word', width: '200px'}}>{row.behavior_comments}</div>,
      sort: true
    },
    {
      dataField: 'teacher_remarks',
      text: 'Teacher Remarks',
      formatter: (cell, row) => <div style={{whiteSpace: 'pre-wrap', wordWrap: 'break-word', width: '200px'}}>{row.teacher_remarks}</div>,
      sort: true
    },
   
   
    {
      dataField: 'completion_status',
      text: 'Completion',
      formatter: (cell, row) => {
        // Use completion_status to calculate percentage
  
        const percentage = (Number(row.completed) / Number(row.total)) * 100;

        return (
          <div className="progress" style={{ height: '20px', backgroundColor: '#000000' }}>
          <div 
            className="progress-bar" 
            style={{ 
              width: `${percentage}%`,
              backgroundColor:  percentage <= 10 ? ' #dc3545':percentage <=50 ? '#dc3174' : percentage <= 80 ? ' #ffc107' : '#28a745',
              color: '#fff',
              textAlign: 'center',
              fontSize: '14px',
              fontWeight: 'bold',
              lineHeight: '20px'
            }} 
            role="progressbar" 
            aria-valuenow={percentage.toFixed(2)} 
            aria-valuemin="0" 
            aria-valuemax="100"
          >
            {percentage.toFixed(2)}%
          </div>
        </div>
        );
      }
    }
  ];

  const paginationOptions = {
    sizePerPage: 100,
    sizePerPageList: [100, 250, 500, 1000],
    firstPageText: 'First',
    prePageText: 'Back',
    nextPageText: 'Next',
    lastPageText: 'Last',
    nextPageTitle: 'First page',
    prePageTitle: 'Pre page',
    firstPageTitle: 'Next page',
    lastPageTitle: 'Last page',
  };



  return (
    <>
      <div className="main-body">
        {isAuthenticated ? (
          <div className="page-wrapper">
            {notice.isLoading && <LoadEffect className="overlay floatLoad" />}
            
            <PageHeader title="Student Homework">
              <li className="breadcrumb-item">
                <a href="#!"><i className="fa fa-fw fa-book"></i></a>
              </li>
              <li className="breadcrumb-item">
                <a href="#!">Homework</a>
              </li>
            </PageHeader>

            <div className="page-body">
          

              {notice.message && (
                <div className="alert alert-danger background-danger">
                  <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                    <i className="fa fa-times text-white"></i>
                  </button>
                  <strong>{notice.message}</strong>
                </div>
              )}

              <div className="row mt-4">
                <div className="col-sm-12">
                  <div className="card z-depth-0">
                    

                    <div className="card-block  ">

<div className='table-responsive'> 

                      <ToolkitProvider
                        keyField="code"
                        data={studentList}
                        columns={columnStudent}
                        search
                      >
                        {props => (
                          <div className="table-responsive">
                            <div className="row mb-3">
                              <div className="col-md-6 w-full">
                                <SearchBar {...props.searchProps} placeholder="Search homework..." />
                              </div>
                            </div>
                            <BootstrapTable
                              {...props.baseProps}
                              pagination={paginationFactory(paginationOptions)}
                              noDataIndication={() => (
                                <div className="text-center">
                                  {notice.isLoading ? (
                                    <TableLoader />
                                  ) : (
                                    <p>No student records found</p>
                                  )}
                                </div>
                              )}
                              striped
                              hover
                              condensed
                            />
                          </div>
                        )}
                      </ToolkitProvider>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
        
            </div>

          </div>
        ) : (
          <Error403 />
        )}
      </div>
    </>
  );
};

export default React.memo(Homework);
